<template>
	<widget v-if="isVisible">
		<div class="clock-in-timer">
			<h3 class="clock-in-timer-title">{{ timerTitle }}</h3>

			<div v-if="timeParts" class="clock-in-timer-display">
				<div class="clock-in-timer-col">
					<div class="clock-in-timer-digits">{{ timeParts[0] }}</div>
					<div class="clock-in-timer-unit">HH</div>
				</div>
				<div class="clock-in-timer-sep">
					<div class="clock-in-timer-digits">:</div>
					<div class="clock-in-timer-unit">:</div>
				</div>
				<div class="clock-in-timer-col">
					<div class="clock-in-timer-digits">{{ timeParts[1] }}</div>
					<div class="clock-in-timer-unit">MM</div>
				</div>
				<div class="clock-in-timer-sep">
					<div class="clock-in-timer-digits">:</div>
					<div class="clock-in-timer-unit">:</div>
				</div>
				<div class="clock-in-timer-col">
					<div class="clock-in-timer-digits">{{ timeParts[2] }}</div>
					<div class="clock-in-timer-unit">SS</div>
				</div>
			</div>

			<div v-else class="clock-in-timer-digits clock-in-timer-fallback">{{ timeElapsed }}</div>
		</div>

		<router-link style="margin: auto;display: block;" to="/punch-clock" class="btn btn-primary">Clock Out</router-link>
	</widget>
</template>

<script type="text/javascript">
import Widget from "@/components/Widget"

export default {
	name: "ClockInTimer",
	components: {
		Widget
	},
	data() {
		return {
			timeElapsed: "",
			timer: null
		}
	},
	computed: {
		isVisible() {
			if (!this.$store.clockedIn)
				return false

			let clockedInJob = this.$store.clockedInJob
			let path = this.$route.path

			let onProjectDashboard = path.indexOf('/project/') == 0 && path.indexOf('/dashboard') >= 0
			let onServiceDashboard = path.indexOf('/service/') == 0 && path.indexOf('/dashboard') >= 0

			if (onProjectDashboard) {
				if (!clockedInJob || clockedInJob.type != 'Job')
					return false
				if (!this.$store.project || !('id' in this.$store.project))
					return false
				if (clockedInJob.id != this.$store.project.id)
					return false
			}

			if (onServiceDashboard) {
				if (!clockedInJob || clockedInJob.type != 'Service')
					return false
				if (!this.$store.service || !('id' in this.$store.service))
					return false
				if (clockedInJob.id != this.$store.service.id)
					return false
			}

			return true
		},
		timerTitle() {
			let job = this.$store.clockedInJob
			if (!job || !job.job_num)
				return "TIME ON JOB"

			if (job.type == "Service")
				return "Time on Service #" + job.job_num

			return "Time on Project #" + job.job_num
		},
		timeParts() {
			if (!this.timeElapsed || this.timeElapsed == "Out of Sync")
				return null

			let parts = this.timeElapsed.split(":")
			if (parts.length != 3)
				return null

			return parts
		}
	},
	methods: {
		refreshElapsed() {
			this.timeElapsed = this.clockInTimeElapsed()
		}
	},
	created() {
		this.refreshElapsed()
		this.timer = setInterval(() => {
			this.refreshElapsed()
		}, 1000)
	},
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style scoped>
.clock-in-timer {
	text-align: center;
	padding: 0.5rem 0.25rem 0.35rem;
}

.clock-in-timer-title {
	font-size: 12pt;
	font-weight: 700;
	letter-spacing: 0.06em;
	color: #0a1f5c;
	margin-bottom: 0.35rem;
}

.clock-in-timer-display {
	display: flex;
	align-items: flex-start;
	justify-content: center;
}

.clock-in-timer-col {
	min-width: 2.4em;
}

.clock-in-timer-digits {
	font-size: 2.85rem;
	font-weight: 600;
	line-height: 1.1;
	color: #0a1f5c;
	font-variant-numeric: tabular-nums;
}

.clock-in-timer-sep .clock-in-timer-digits {
	padding: 0 0.1rem;
}

.clock-in-timer-unit {
	font-size: 0.75rem;
	font-weight: 500;
	color: #a8b0c0;
	letter-spacing: 0.04em;
	margin-top: 0.15rem;
}

.clock-in-timer-sep .clock-in-timer-unit {
	color: #c5cad6;
}

.clock-in-timer-fallback {
	padding: 0.25rem 0;
}
</style>
